export class RecruitmentPortalNavigation {
	static getRouter() {
		if ( window.IndexViewController && window.IndexViewController.instance && window.IndexViewController.instance.router ) {
			return window.IndexViewController.instance.router;
		}

		return false;
	}

	static isModifiedClick( e ) {
		return e && ( e.ctrlKey || e.metaKey || e.shiftKey || e.which === 2 || e.button === 1 );
	}

	static getPortalViewArgs( view_id, route_args, options ) {
		options = options || {};
		var args = {};
		if ( options.keep_current_args !== false ) {
			args = $.extend( {}, LocalCacheData.getAllURLArgs() || {} );
		}

		if ( Array.isArray( options.remove_args ) ) {
			for ( var i = 0; i < options.remove_args.length; i++ ) {
				delete args[options.remove_args[i]];
			}
		}

		args = $.extend( args, route_args || {} );
		args.m = view_id;

		return args;
	}

	static hasSensitiveURLArgs( args ) {
		args = args || {};

		return args.key != null
				|| args.password != null
				|| args.user_name != null
				|| args.sm === 'ResetPassword';
	}

	static getURLSafeArgs( args ) {
		var safe_args = $.extend( {}, args || {} );

		if ( safe_args.sm === 'ResetPassword' ) {
			delete safe_args.sm;
		}

		delete safe_args.key;
		delete safe_args.password;
		delete safe_args.user_name;

		return safe_args;
	}

	static getRouteStringFromArgs( args ) {
		var route_parts = [];
		args = args || {};

		for ( var key in args ) {
			if ( !Object.prototype.hasOwnProperty.call( args, key ) ) {
				continue;
			}

			var value = args[key];
			if ( value === undefined || value === null || value === '' ) {
				continue;
			}

			if ( Array.isArray( value ) ) {
				for ( var i = 0; i < value.length; i++ ) {
					route_parts.push( encodeURIComponent( key + '[]' ) + '=' + encodeURIComponent( value[i] ) );
				}
			} else {
				route_parts.push( encodeURIComponent( key ) + '=' + encodeURIComponent( value ) );
			}
		}

		return route_parts.join( '&' );
	}

	static getURLFromArgs( args ) {
		var route_string = this.getRouteStringFromArgs( this.getURLSafeArgs( args ) );
		return Global.getBaseURL( null, false, false ) + ( route_string != '' ? '?' + route_string : '' );
	}

	static getPortalViewURL( view_id, route_args, options ) {
		var router = this.getRouter();
		if ( router ) {
			return router.getPortalViewURL( view_id, route_args, options );
		}

		return this.getURLFromArgs( this.getPortalViewArgs( view_id, route_args, options ) );
	}

	static goToPortalView( view_id, route_args, options ) {
		var router = this.getRouter();
		if ( router ) {
			router.goToPortalView( view_id, route_args, options );
		} else {
			window.location = this.getPortalViewURL( view_id, route_args, options );
		}
	}

	static handlePortalViewClick( e, view_id, route_args, options ) {
		if ( this.isModifiedClick( e ) ) {
			return true;
		}

		if ( e ) {
			e.preventDefault();
		}

		this.goToPortalView( view_id, route_args, options );
		return false;
	}
}
